
import React, { Component } from "react";

class TerrainReview extends Component{

    constructor(props){
        super(props)
        this.svrreview = {
           
            "num_reviews": 12364,
            "num_reviews_text": "reviews",
            "sv_rating": "Excellent",
            "sv_rating_no": 5
        }
            }
    render(){
        const ars = [];
        console.log('############### this.props.svrlocation ****************')
        console.log(this.props.svrreview)

        
      


       
        return (

            <div className="svr-box-rr">
                <div className="svr-box-rr-c1">
                    <div className="svr-rating-content">
                    <span className='svr-text'> {this.props.svrreview.sv_rating} </span>  <p className="badge badge-red">5.0</p>
                    </div>
                    <div className="svr-num-reviews-content">
                        <p> {this.props.svrreview.num_reviews} reviews
                        </p>
                    </div>
                </div>
            </div>
        )
    }
   
}

export default TerrainReview;